import { CSATFeedback } from "graphql/types/globalTypes";

const NEXT_PUBLIC_APOLLO_247_AUTH_URL =
  process.env.NEXT_PUBLIC_APOLLO_247_AUTH_URL;
const NEXT_PUBLIC_SSR_API_HOST_NAME = process.env.NEXT_PUBLIC_SSR_API_HOST_NAME;
const SBI_REF_CODE = "SBIYONO";
const HDFC_REF_CODE = "HDFCBANK";
const PARTNER_TP_REF_CODES = [SBI_REF_CODE, HDFC_REF_CODE];
const HDFC_EXOTEL_CALLERID = "04048217258";
const HDFC_EXOTEL_NUMBER = "--To Be Filled Later--";
const HDFC_ENROLL_LINK =
  "https://apply.hdfcbank.com/vivid/s_account_newuiux?LGCode=HFAP&mc_id=hfap_mobileapp&utm_source=apollo&utm_medium=mobileapp&utm_campaign=apollo_app_hf_ntb";
const EXOTEL_CALL_URL =
  "https://notifications.apollo247.com/webhooks/exotel/call";
const EXOTEL_X_API = "gNXyYhY2VDxwzv8f6TwJqvfYmPmj";

const HOME_PRELOAD_IMG_MOBILE =
  "https://newassets.apollo247.com/images/banners/mweb_First3.jpg";
const HOME_PRELOAD_IMG_DESKTOP =
  "https://newassets.apollo247.com/images/img-doctors@1x.jpg";

const HDFC_SUBSCRIPTION_GOLD = {
  coupons: {
    HDFCGold1: "Discount of Rs 249 on Virtual Consultations for HDFC customers",
    HDFCGold2:
      "Discount on Medicines and Apollo Private Label for HDFC customers",
    HDFCGold3: "Discount on Medicines for HDFC customers",
  },
};

const NEXT_PUBLIC_247_CDN_URL =
  process.env.NEXT_PUBLIC_247_CDN_URL || "https://newassets.apollo247.com";

const NEXT_APOLLO_247_CIRCLE_URL = process.env.NEXT_APOLLO_247_CIRCLE_URL;
const NEXT_PUBLIC_LAZYPAY_TERMS_AND_CONDITIONS_URL =
  process.env.NEXT_PUBLIC_LAZYPAY_TERMS_AND_CONDITIONS_URL;
const NEXT_PUBLIC_PHARMACY_PG_URL = process.env.NEXT_PUBLIC_PHARMACY_PG_URL;

const CARE_TERMS_AND_CONDITIONS = [
  `CIRCLE Membership Programme is the marketing programme (“Programme”) offered by Apollo 24|7, a digital healthcare platform managed by Apollo Healthco Limited (AHL).`,

  `The validity of the Programme (“Term”) will be according to the plan selected and enrolled by the customer (“Member”).`,

  `The discounts and cashbacks offered under the Programme shall be applied at the time of payment checkout by the Member.`,

  `The offerings under the Programme will differ with the different categories as per the selection made by the Member.`,

  `The Programme is non-transferable.`,

  `After completing the transaction you will be able to enjoy the benefits of the Programme within 24 hours.`,

  `By enrolling in the Programme, a Member consents to allow AHL to use, disclose, store, process, transfer, etc, his/her personal and other sensitive personal data or information as provided by the Member at the time of enrolment by AHL or any of its subsidiaries, associates, affiliates or group companies.`,

  `As a prerequisite to becoming a Member of the Programme, a Member is required to provide mandatory information including full name, active and valid Indian mobile number.`,

  `He/she shall be governed by the Terms and Conditions as may be prescribed for Membership from time to time.`,

  `The Program will be issued solely at the discretion of the management and the final discretion on all matters relating to the Membership shall rest with AHL.The Programme cannot be availed for transactions carried out at outlets/physical stores operated by Apollo HealthCo Limited (AHL) in hospitals and outlets operated by Apollo Pharmacy Limited(APL) in Apollo Cradle & Children’s Hospital, Apollo Spectra Hospitals and in stores at airports and other corporate hospitals.`,

  `AHL reserves the right to add, alter, amend, modify and revise the aforesaid terms and conditions at any time and in its sole discretion without prior notice, intimation and permission.`,

  `Benefits and offers available through the Programme may change or can be withdrawn/discontinued(either temporarily or permanently) without prior notice, intimation or permission. Customer agrees that AHL will not be responsible or liable, in any manner, for any liability, losses, damages, injuries or expenses incurred by the Customer, arising from such change or withdrawal or use of such offers. Further, the Customer understands and agrees that, he/she may be denied the benefits of Circle Membership, if such Person utilises any discount coupons available at the time, which shall be at the sole discretion of AHL, and that the person may not be entitled to claim any benefits of Circle Membership with usage of such discount coupons.`,

  `The Programme cannot be cancelled by the Member and the Member is not eligible for refund and cancellation of the fees. In special circumstances, the request for cancellation may be considered by the management on a case to case basis and the fees may be refunded to the Member at the sole discretion of the management.`,

  `Any disputes arising out of the Programme shall be governed by the laws of India. Any legal action or proceedings related to this Programme shall be subject to the exclusive jurisdiction of the courts at Chennai. All disputes shall be subject to arbitration by a sole arbitrator appointed by AHL for this purpose. The proceedings of the arbitration shall be conducted as per the provisions of Arbitration and Conciliation Act, 1996 or any statutory modifications and alterations thereto. The place of arbitration shall be at Chennai and language of arbitration shall be English. The existence of a dispute, if at all, shall not constitute a claim against AHL.`,

  `If any Member has any grievance, comment, question or suggestion regarding any of the terms of this Program, please contact our team through the help section available in My Account page.`,

  `If any provision of these Terms and conditions is deemed invalid, unlawful, void or for any other reason unenforceable, then that provision shall be deemed severable from these Terms and conditions and shall not affect the validity and enforceability of any of the remaining terms.`,

  `The Member accepts and acknowledges that AHL shall not be liable for any loss or damage caused to the Member as a result of delay or default or deficiency or failure in the services as a result of any natural disasters, fire, riots, civil disturbances, actions or decrees of governmental bodies, communication line failures (which are not caused due to the fault of AHL or the third party service providers), or any other delay, default, deficiency or failure which arises from causes beyond AHL’s reasonable control.`,

  `By accepting these Terms and Conditions, the Member, also accepts and agrees to be bound by AHL policies, including Apollo 24|7 Terms & Conditions (as set out here https://www.apollo247.com/terms) and the Privacy Policy (as set out on our website https://www.apollo247.com/privacy), and such other rules, guidelines, policies, terms and conditions as are relevant under the applicable law(s) in India and other jurisdictions for the purposes of availing any of the services, and such rules, guidelines, policies, terms and conditions shall be deemed to be incorporated into, and considered as part and parcel of these Terms and Conditions.`,
];

const CARE_FAQ = [
  {
    faqQuestion: "What is Apollo 24|7 CIRCLE membership programme?",
    faqAnswer:
      "Apollo 24|7 CIRCLE membership is a one-of-its-kind programme designed to deliver the best care and value to its members. Once you sign up with the plan of your choice, you will receive benefits such as priority access to doctors, cashback on medicines, free home delivery and discounts on doctor consultations and diagnostics.",
  },
  {
    faqQuestion: "How many plans are there in CIRCLE membership?",
    faqAnswer:
      "There are 3 plans available for you to choose from- INR 99 for 2 months, INR 199 for 6 months, and INR 299 for 12 months.",
  },
  {
    faqQuestion: "How do I sign up for CIRCLE membership?",
    faqAnswer:
      "It’s simple! If you’re a part of Apollo 24|7 already, you can click on the link above and sign up. If you’re new to Apollo 24|7, you can get started by creating an account.",
  },
  {
    faqQuestion: "Is annual membership better than monthly membership?",
    faqAnswer:
      "Yes, if you want to save big! The yearly membership only costs you INR 299, which translates to INR 25 per month.",
  },
  {
    faqQuestion: "Can I buy CIRCLE membership using Health Credits?",
    faqAnswer:
      "Absolutely, if you have Health Credits worth the price of the membership. Otherwise you can always pay via our easy payment methods. ",
  },
  {
    faqQuestion: "Where will I get CIRCLE cashback?",
    faqAnswer:
      "You will be eligible for CIRCLE cashback every time you buy medicines or Apollo products and lab tests bookings except when you have utilised certain specific coupons available on Apollo 24|7 for which Circle cashback would not be applicable. The terms of such specific coupons shall supersede the Circle cashback. We also have discounts on selected doctor consultations and diagnostic tests. Cashback will be credited to your OneApollo Health Credits as soon as a transaction gets completed.",
  },
  {
    faqQuestion: "How can I use CIRCLE cashback?",
    faqAnswer:
      "You can use your CIRCLE cashback as Health Credits to buy medicines and Apollo branded products; and on diagnostic tests on Apollo 24|7.",
  },
  {
    faqQuestion: "Can the offers change after I buy the membership?",
    faqAnswer:
      "Yes, it’s possible but we always aim to upgrade benefits so that you get the best out of your CIRCLE membership.",
  },
  {
    faqQuestion:
      "What does CIRCLE cashback mean? Is it different from OneApollo cashback?",
    faqAnswer:
      "Every time you make a transaction through CIRCLE, you will be rewarded with CIRCLE Cashback that you can use to purchase medicines and Apollo-branded products. It’s the same as OneApollo Cashback. However, CIRCLE cashback will not be applicable if you choose to utilise the certain specific Coupons available on Apollo 24|7. The terms of such specific coupons shall supersede the Circle Benefits.",
  },
  {
    faqQuestion: "Can CIRCLE cashback be used for a virtual consultation?",
    faqAnswer:
      "Not yet, but you can use your CIRCLE cashback as Health Credits to order the prescribed medicines after your consultation.",
  },
  {
    faqQuestion:
      "Will some of these features be a part of the Apollo Hospital experience as well?",
    faqAnswer:
      "Not as of now, but we are working towards it so you get the best out of CIRCLE.",
  },
  {
    faqQuestion:
      "Are CIRCLE benefits applicable for physical appointments at Apollo Hospitals? ",
    faqAnswer:
      "Not as of now, but we are working towards it so you get the best out of Circle",
  },
  {
    faqQuestion:
      "Are CIRCLE benefits applicable on hospital visits booked through Apollo 24|7?",
    faqAnswer:
      "No, CIRCLE benefits are applicable only in cases of virtual consultation with doctors on the Apollo 24|7 app.",
  },
];

const EXOTEL_CALL_PROMPT = {
  DCOTOR_CONNECTING: `You'll be connected to the Doctor in a while`,
  CONNECT_ERROR: `Error while connecting to the Doctor, Please try again`,
};

const TERMS_AND_CONDITION_WARNING_MESSAGE = `Without agreeing to the Terms and Conditions, 
you’ll not be able to register for corporate benefits. For any
other query, please write to us at corporate-helpdesk@apollo247.com`;

const ALL_CITIES = [
  "All Cities",
  "Hyderabad",
  "Chennai",
  "Mumbai",
  "Kolkata",
  "Bangalore",
];

const SELECTED_CITIES = [
  "Hyderabad",
  "Chennai",
  "Mumbai",
  "Kolkata",
  "Bangalore",
];

const PROMPT = "prompt";

const GRANTED = "granted";
const SORTBY = {
  DISTANCE: "distance",
  AVAILABILITY: "availability",
  PRICE_ASCENDING: "price_ascending",
  PRICE_DESCENDING: "price_descending",
  EXPERIENCE: "experience",
};

const ICONS_PATHS = [
  "path1",
  "path2",
  "path3",
  "path4",
  "path5",
  "path6",
  "path7",
  "path8",
  "path9",
  "path10",
  "path11",
  "path12",
  "path13",
  "path14",
  "path15",
  "path16",
  "path17",
  "path18",
  "path19",
  "path20",
  "path21",
  "path22",
  "path23",
  "path24",
  "path25",
  "path26",
  "path27",
  "path28",
  "path29",
  "path30",
];

const ACTIVE = "active";
const SITEMAP = "sitemap";

const SITE_MAP = {
  "doctors-sitemap": {
    metaTitle: `Apollo 247 - List of All Doctors in India for Online Consultation | Page `,
    metaDescStart: `Explore Apollo 247 Sitemap`,
    metaDescEnd: `to know about the online doctor consultation, Apollo Doctors and to easily navigate within the website`,
    title: "Doctors Sitemap",
    dataUrls: "doctorUrls",
    apiUrls: "doctorUrlsList",
  },
  "city-specialty-sitemap": {
    metaTitle: `Apollo 247 - List of Specialist Doctors by City for Online Consultation | Page `,
    metaDescStart: `Apollo 247 - List of Specialist Doctors by City for Online Consultation | Page`,
    metaDescEnd: `- check the best Specialist doctors by city for online consultation.`,
    title: "Specialist Doctors By City Sitemap",
    dataUrls: "citySpecialityUrls",
    apiUrls: "citySpecialityUrlsList",
  },
  "city-doctors-sitemap": {
    metaTitle: `Apollo 247 - List of Doctors By City for Online Consultation | Page `,
    metaDescStart: `Apollo 247 - List of Doctors By City for Online Consultation | Page`,
    metaDescEnd: `- check the best Doctors By City for online consultation.`,
    title: "Doctors By City Sitemap",
    dataUrls: "cityDoctorUrls",
    apiUrls: "cityDoctorUrlsList",
  },
  "locality-specialty-sitemap": {
    metaTitle: `Apollo 247 - List of Specialist Doctors By Locality for Online Consultation | Page `,
    metaDescStart: `Apollo 247 - List of Specialist Doctors By Locality for Online Consultation | Page `,
    metaDescEnd: `-  check the best Specialist Doctors By Locality for online consultation.`,
    title: "Specialist Doctors By Locality Sitemap",
    dataUrls: "localitySpecialityUrls",
    apiUrls: "localitySpecialityUrlsList",
  },
  "locality-doctors-sitemap": {
    metaTitle: `Apollo 247 - List of Doctors By Locality for Online Consultation | Page `,
    metaDescStart: `Apollo 247 - List of Doctors By Locality for Online Consultation | Page `,
    metaDescEnd: `- check the best Doctors By Locality for online consultation.`,
    title: "Doctors By Locality Sitemap",
    dataUrls: "localityDoctorUrls",
    apiUrls: "localityDoctorUrlsList",
  },
  "near-me-specialty-sitemap": {
    metaTitle: `Apollo 247 - List of Specialties Doctors Near you for Online Consultation | Page `,
    metaDescStart: `Apollo 247 - List of Specialties Doctors Near you for Online Consultation | Page`,
    metaDescEnd: `- check the best Specialties Doctors Near you for online consultation.`,
    title: "Specialty Doctors Near Me Sitemap",
    dataUrls: "specialityNearMeUrls",
    apiUrls: "specialityNearMeUrlsList",
  },
  "specialties-sitemap": {
    metaTitle: `Apollo 247 - List of Specialties for Online Consultation | Page `,
    metaDescStart: `Apollo 247 - List of Specialties for Online Consultation | Page`,
    metaDescEnd: `- check the best Specialties for online consultation.`,
    title: "Specialities Sitemap",
    dataUrls: "specialityUrls",
    apiUrls: "specialityUrlsList",
  },
  "article-sitemap": {
    metaTitle: `Apollo 247 - List of Article | Page `,
    metaDescStart: `Apollo 247 - List of Article | Page`,
    metaDescEnd: ``,
    title: "Article Sitemap",
    dataUrls: "articleUrls",
    apiUrls: "articleUrlsList",
  },
  "static-sitemap": {
    metaTitle: `Apollo 247 - List of Static pages | Page `,
    metaDescStart: `Apollo 247 - List of Static pages | Page`,
    metaDescEnd: ``,
    title: "Static Sitemap",
    dataUrls: "staticPageUrls",
    apiUrls: "staticPageUrlsList",
  },
  "diagnostic-sitemap": {
    metaTitle: `Apollo 247 - List of Diagnostic pages for health checkups | Page `,
    metaDescStart: `Apollo 247 - List of Diagnostic pages for health checkups | Page `,
    metaDescEnd: `- check the Diagnostic pages for health checkups`,
    title: "Diagnostic Sitemap",
    dataUrls: "labTestsDetailsUrls",
    apiUrls: "labTestsDetailsUrlsList",
  },
  "diagnostic-categories": {
    metaTitle: `Apollo 247 - List of Diagnostic Category Lists for health checkups | Page `,
    metaDescStart: `Apollo 247 - List of Diagnostic Category pages for health checkups | Page `,
    metaDescEnd: `- check the Diagnostic pages for health checkups`,
    title: "Diagnostic Categories",
    dataUrls: "labTestsCategoryUrls",
    apiUrls: "labTestCategoryUrlsList",
  },
  "health-query-categories": {
    metaTitle: `Apollo 247 - List of Health Query categories and pages | Page `,
    metaDescStart: `Apollo 247 - List of Health Query categories and pages | Page `,
    metaDescEnd: `- check the Health Query pages for health`,
    title: "Helath Query Categories",
    dataUrls: "healthQueryUrls",
    apiUrls: "healthQueryUrlsList",
  },
  "hospitals-and-clinic-sitemap": {
    metaTitle: `Apollo 247 - List of Hospital Details and pages | Page `,
    metaDescStart: `Apollo 247 - List of Hospital Details and pages | Page `,
    metaDescEnd: `- check the Hospitals Details pages for Hospitals`,
    title: "Hospital Details",
    dataUrls: "hospitalDetailUrls",
    apiUrls: "hospitalDetailUrlsList",
  },
  "hospitals-city-and-region": {
    metaTitle: `Apollo 247 - List of Hospitals City & Region and pages | Page `,
    metaDescStart: `Apollo 247 - List of Hospitals City & Region and pages | Page `,
    metaDescEnd: `- check the Hospitals City & Region for Hospitals`,
    title: "Hospitals City & Region",
    dataUrls: "hospitalLocationUrls",
    apiUrls: "hospitalLocationUrlsList",
  },
  "disease-and-conditions": {
    metaTitle: `Apollo 247 - List of Diseases and Conditions and pages | Page `,
    metaDescStart: `Apollo 247 - List of Diseases and Conditions and pages | Page `,
    metaDescEnd: `- check the Diseases and Conditions pages for health`,
    title: "Diseases and Conditions",
    dataUrls: "diseaseAndConditionsUrls",
    apiUrls: "diseaseAndConditionsUrlsList",
  },
};

const ACTIVE_STATUS = "ACTIVE";

const BREADCRUMBS = {
  HOME: "Home",
  SITEMAP: "Sitemap",
};

const DEFERRED_ACTICE = "deferred_active";

const GETSITEMAP_METADATA = {
  TITLE: "Sitemap | Apollo 247 - Apollo Doctors and Online Pharmacy",
  DESC:
    "Explore Apollo 247 Sitemap to know about the online doctor consultation, online pharmacy, Covid-19 Vaccine, Covid-19 Articles and to easily navigate within the website",
};

const POLITICAL = "political";

const caloriesDuration = [
  "15 Minutes",
  "30 Minutes",
  "45 Minutes",
  "1 Hour",
  "2 Hours",
  "3 Hours",
  "4 Hours",
  "5 Hours",
  "6 Hours",
  "7 Hours",
  "8 Hours",
  "9 Hours",
  "10 Hours",
  "11 Hours",
];

const MINIMUM_CUSTOM_OFFER_MESSAGE_AMOUNT = 50;
export enum IS_APP_USER {
  APP_USER = "true",
}

export const DEAL_PAGES_SOURCES = {
  DEAL_PAGE: "Deal Page",
  DIAGNOSTICS_PAGE: "Diagnostic Homepage",
  CONSULT_PAGE: "Consult Homepage",
  PHARMA_PAGE: "Pharma Homepage",
};
export const OUT_OF_CONSULT_HOUR_ERROR =
  "Slot selected seems to be unavailable.. Please retry booking with other available slots!";

export enum PROFILE_SUCCESS_MESSAGE {
  PROFILE_CREATED = "Profile created successfully.",
  PROFILE_UPDATED = "Profile updated successfully.",
  PROFILE_DELETED = "Profile deleted successfully.",
}

export const MAX_ALLOWED_PROFILE_COUNT = 100;

export const MOBILE_NUMBER_WITH_PREFIX_ERROR =
  "Mobile Number should start with +91 followed by 10 digits";

export const SERVICE_UNAVAILABLE_AT_PINCODE_MESSAGE = `Sorry! We’re working hard to get to this area! In the
meantime, you can either pick up from a nearby store, or
change the pincode.`;

export const CALL_PHARMACY_CUSTOMER_CARE_MESSAGE = `You can also call 1860 500 0101 for Apollo Pharmacy retail
customer care.`;
export const LINKABLE_METHODS_OTP_LENGTH = 6;

const DOC_ON_CALL = "DOC_ON_CALL";
const CIRCLE = "circle";
const FAMILY = "family-doctor-plan";

const CIRCLEBENEFITS = "CIRCLEBENEFITS";

const DIABETES_FORM_ELEMENTS = [
  {
    value: "Pre-Diabetes",
    label: "Pre-Diabetes",
  },
  {
    value: "Diabetes1",
    label: "Type 1 Diabetes",
  },
  {
    value: "Diabetes2",
    label: "Type 2 Diabetes",
  },
  {
    value: "Diabetes3",
    label: "Gestational Diabetes",
  },
];

const DIABETES_YEARS_FORM_ELEMENTS = [
  {
    value: "Pre-Diabetes",
    label: "Pre-Diabetes",
  },
  {
    value: "Diabetes1",
    label: "Type 1 Diabetes",
  },
  {
    value: "Diabetes2",
    label: "Type 2 Diabetes",
  },
  {
    value: "Diabetes3",
    label: "Gestational Diabetes",
  },
];

export {
  NEXT_PUBLIC_APOLLO_247_AUTH_URL,
  NEXT_PUBLIC_SSR_API_HOST_NAME,
  SBI_REF_CODE,
  HDFC_REF_CODE,
  PARTNER_TP_REF_CODES,
  HDFC_EXOTEL_NUMBER,
  HDFC_EXOTEL_CALLERID,
  HDFC_SUBSCRIPTION_GOLD,
  EXOTEL_CALL_URL,
  EXOTEL_X_API,
  HOME_PRELOAD_IMG_MOBILE,
  HOME_PRELOAD_IMG_DESKTOP,
  HDFC_ENROLL_LINK,
  CARE_TERMS_AND_CONDITIONS,
  CARE_FAQ,
  EXOTEL_CALL_PROMPT,
  TERMS_AND_CONDITION_WARNING_MESSAGE,
  ALL_CITIES,
  SELECTED_CITIES,
  PROMPT,
  GRANTED,
  SORTBY,
  ICONS_PATHS,
  SITE_MAP,
  ACTIVE,
  BREADCRUMBS,
  SITEMAP,
  GETSITEMAP_METADATA,
  ACTIVE_STATUS,
  DEFERRED_ACTICE,
  POLITICAL,
  caloriesDuration,
  MINIMUM_CUSTOM_OFFER_MESSAGE_AMOUNT,
  NEXT_PUBLIC_247_CDN_URL,
  NEXT_PUBLIC_LAZYPAY_TERMS_AND_CONDITIONS_URL,
  NEXT_APOLLO_247_CIRCLE_URL,
  NEXT_PUBLIC_PHARMACY_PG_URL,
  DOC_ON_CALL,
  CIRCLE,
  FAMILY,
  CIRCLEBENEFITS,
  DIABETES_FORM_ELEMENTS,
  DIABETES_YEARS_FORM_ELEMENTS,
};

export const VOUCHER_MESSAGE = {
  APPROVAL: "APPROVAL",
  INVALID_CARD: "Invalid card number",
  INVALID_PIN: "Invalid Issuance Number. Request Failed",
  EXPIRED: "Card is Expired",
};

export const TIMEOUT = {
  GOOGLE_SIGN_IN_POP_UP_TIMEOUT: 10000,
};

export const TOKEN_REFETCH_DURATION = 3540000;
export const CACHE_EXPIRE_IN_MINUTES = 30;

export const PartnersConfig = {
  "sbi-general": {
    partnerLogoUrl: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/sbi-logo.png`,
    primaryText: `For your holistic wellbeing, SBI joins hands with Apollo 24|7,
      India’s largest digital healthcare platform, to bring you instant
      online doctor consultation, 2-hour* medicine delivery, and up to
      60% savings on diagnostic tests - all through one app!`,
    secondaryText: `With SBI General Customer Health Supreme Package, you will receive
      the following benefits valid for 12 months:`,
    heroImageUrl: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/hero-img.png`,
    packageName: "SBI-exclusive",
    banners: [
      {
        numberOfVouchers: 2,
        worth: 249,
        code: "SBIV",
        image: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/video-consultations.png`,
        altText: "Apollo SBI Voucher",
        termsAndCondition:
          "each for voice/video consultations of ₹799 or above",
      },
      {
        numberOfVouchers: 12,
        code: "SBIM",
        image: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/mobile-cart.png`,
        altText: "Apollo SBI Voucher",
        termsAndCondition:
          "for online medicine orders of ₹899 or above, applicable once per month.",
        worth: 100,
      },
      {
        code: "SBIN",
        image: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/pkg-3.jpeg`,
        altText: "Apollo SBI Voucher",
        termsAndCondition: "1 complimentary online consultation with a ",
        termsAndConditionSpanText: "top Apollo nutritionist.",
        isConsultation: true,
      },
    ],
  },
};

export const PartnerSuccessLoginMessage =
  "Congratulations! Your FREE offers shall be activated in 24hours";

export const circleBenefitsArray = [
  {
    primaryText: "Attractive cashbacks",
    secondaryText: "on medicines & online doctor consultations.",
    imageUrl: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/cash-back.svg`,
    altText: "cashback",
  },

  {
    primaryText: "3 Emergency voice calls for doctor",
    secondaryText: "support per month.",
    imageUrl: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/dr.svg`,
    altText: "doctor image",
  },
  {
    primaryText: "FREE 2-hour* express delivery",
    secondaryText: "on medicine orders.",
    imageUrl: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/truck.svg`,
    altText: "truck image",
  },
  {
    primaryText: "Up to 60% OFF on diagnostic tests",
    imageUrl: `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/partners/test.svg`,
    altText: "diagnostic test image",
  },
];

export const benefitAvailSteps = [
  {
    primaryHeading: "Steps to avail benefit 1 & 3",
    secondaryHeading: "E-consultations",
    className: "consultation",
    steps: [
      `Select your preferred doctor/nutritionist for online consultation.`,
      `Select the preferred date & time slot for your doctor, and select the patient’s name.`,
      `At checkout, click on “Apply Coupon” & select/paste the voucher code.`,
      `Hit “Apply”. The discount will be applied.`,
    ],
  },
  {
    primaryHeading: "Steps to avail benefit 2",
    secondaryHeading: "Pharmacy",
    className: "pharmacy",
    steps: [
      "Build your medicine order.",
      `At checkout, click on "Apply Coupon” & select/paste the voucher code.`,
      `Hit “Apply”. The discount will be applied.`,
    ],
  },
  {
    primaryHeading: "Steps to avail benefit 4",
    secondaryHeading: "Explore CIRCLE membership",
    className: "circle",
    steps: [
      `Click on “My Account” & select “My Membership”.`,
      `Go to “View Details” under the CIRCLE plan & get started.`,
    ],
  },
];
export const PAYMENT_FAILED_TYPES = ["FAILED", "ABORTED", "PENDING"];
export const SEARCHED_ARTICLE_LIST_LIMIT = 12;
export const ENTER_KEY = "Enter";
export enum PLATFORM_TYPE {
  mWeb = "m-Web",
  Web = "Web",
}

export const lazyPayInfoArray = [
  "Seamless one click payment",
  "0% interest and no hidden fees",
  "Repay every 15 days",
  "100% safe and secure",
];
export const lazyPayConditionMessage =
  "By clicking on Link Wallet, you are agreeing to these";

export enum METHOD_CONTAINER_TYPE {
  REWARD = "REWARD",
  PAY_LATER = "PAY LATER",
}

export const OFFER_ERROR_CODES = {
  OFFER_FAILURE: ["JP701", "JP703"],
  INTERNAL_ERROR: ["JP702", "JP704", "JP705", "JP706", "JP708"],
};

export const JUSPAY_ERROR_STRING = {
  OFFER_FAILURE: "This offer is not valid for this transaction",
  INTERNAL_ERROR: "Internal Error while applying the offer",
};
export const PAYMENT_PAGE_PATH_NAME = "/payments/[category]/[orderId]";

export const CIRLE_USER_AVAILABLE_HC = 49;

export const TYPE_OF_LAB_TEST_LISTING_PAGE = {
  TEST_LISTING: "test-listing",
  LAB_TESTS_CATEGORY: "lab-tests-category",
};

export const HEALTH_TOOLS = {
  CALORIES_REQUIRED: "Calories Required",
  CALORIES_BURNT: "Calories Burnt",
};

export const HEALTH_TOOLS_EVENTS_INIT = {
  "Body Mass Index": "bmi_calculator_started",
  "Calories Required": "calories_required_initiated",
  "Calories Burnt": "calories_burnt_initiated",
  "Heart Health Tool": "heart_health_initiated",
};

export const ALL_PROFILE_LABEL = "All";

export const NETBANKING_OUTAGE_STATUS_MESSAGES = {
  DOWN:
    "Few banks are currently disabled due to high failures. Please try another payment option",
  FLUCTUATE:
    "Few banks are experiencing high failures. Please try another payment option.",
};

export const getCSATText = (value: CSATFeedback) => {
  switch (value) {
    case CSATFeedback.POOR:
      return {
        question: "What went wrong?",
        options: [
          "Received incorrect or incomplete reports",
          "Did not get the required time slot",
          "Sample collection experience",
          "Inappropriate behaviour of sample collection executive",
          "Insufficient communication regarding order updates",
          "Difficulty in finding the required tests/packages",
          "Others",
        ],
      };
    case CSATFeedback.OKAY:
      return {
        question: "What could have been improved?",
        options: [
          "Report generation time",
          "Sample collection experience",
          "Booking Experience",
          "Availability of time slots for sample collection",
          "Availability of customised tests and packages",
          "Communication regarding order updates",
          "Others",
        ],
      };
    case CSATFeedback.GOOD:
      return {
        question: "Thanks! What could make this a Great experience for you?",
        options: [
          "Report generation time",
          "Sample collection experience",
          "Booking Experience",
          "Availability of time slots for sample collection",
          "Availability of customised tests and packages",
          "Communication regarding order updates",
          "Others",
        ],
      };
    case CSATFeedback.GREAT:
      return {
        question: "Thanks! What went well?",
        options: [
          "Report generation time",
          "Sample collection experience",
          "Booking Experience",
          "Availability of time slots for sample collection",
          "Availability of customised tests and packages",
          "Communication regarding order updates",
          "Others",
        ],
      };
  }
};

export const MINIMUM_CHARACTERS_BLOG_SEARCH = 3;

export const HEALTH_RECORDS_NAVS = {
  PRESCRIPTION: "Prescription",
  BILL: "Bill",
  HOSPITALIZATION: "Hospitalization",
};

export enum PROHEALTH_BANNER_SOURCE {
  HOME_CAROUSEL = "Home page Carousel",
  HOME_MAIN_BANNER = "Home page main banner",
  DIAGNOSTIC_PAGE = "Diagnostic home page",
}

export const prohealth = "prohealth";
export const CACHE_TIMEOUT_IN_MINUTES = 60;
export const WHATSAPP_CHAT_LINK = "https://api.whatsapp.com/send";

export const PATHTOSECTIONMAPPER = {
  homePage: "Apollo247 Homepage",
  "lab-tests": "Lab Tests",
  circle: "Circle",
  "health-records": "Health Records",
  specialties: "Consult",
};

export const SECTIONNAMES = {
  CORPORATE_DISCLOSURE: "Corporate Disclosures",
  HEALTH_RECORDS: "Health Records",
};
